package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

// SECTIONS DE LA PAGE (MOBILE VS DESKTOP)
//val ChooseCvMobileContainerStyle = CssStyle {
//    base {
//        Modifier
//            .display(DisplayStyle.Flex)
//            .fillMaxWidth()
//            .padding(top = 30.px, leftRight = 25.px)
//    }
//    Breakpoint.MD {
//        Modifier.display(DisplayStyle.None)
//    }
//}
//
//val ChooseCvDesktopContainerStyle = CssStyle {
//    base {
//        Modifier.display(DisplayStyle.None)
//    }
//    Breakpoint.MD {
//        Modifier
//            .display(DisplayStyle.Flex)
//            .fillMaxWidth()
//            .padding(top = 30.px, right = 700.px, bottom = 15.px)
//    }
//}
//
//// TYPOGRAPHIE
//val ChooseCvTitleStyle = CssStyle {
//    base {
//        Modifier
//            .fontSize(24.px)
//            .padding(bottom = 10.px)
//    }
//    cssRule(" span") {
//        Modifier.styleModifier { property("font-size", "inherit") }
//    }
//    Breakpoint.MD {
//        Modifier
//            .fontSize(36.px)
//            .padding(bottom = 0.px)
//    }
//}
//
//val ChooseCvSubtitleStyle = CssStyle {
//    base {
//        Modifier
//            .fontSize(13.px)
//            .margin(bottom = 25.px)
//    }
//    cssRule(" span") {
//        Modifier.styleModifier { property("font-size", "inherit") }
//    }
//    Breakpoint.MD {
//        Modifier
//            .fontSize(16.px)
//            .margin(bottom = 0.px)
//    }
//}
//
//// CARTE CV (ChooseModelStyle & CvCards)
//val CvCardBoxStyle = CssStyle {
//    base {
//        Modifier
//            .width(340.px)
//            .height(490.px)
//    }
//    Breakpoint.MD {
//        Modifier
//            .width(330.px)
//            .height(460.px)
//    }
//}
//
//// HEADER BAR STYLES
//val HeaderPaddingStyle = CssStyle {
//    base { Modifier.padding(16.px) }
//    Breakpoint.SM { Modifier.padding(18.px) }
//    Breakpoint.MD { Modifier.padding(20.px) }
//}
//
//val HeaderHomeMarginStyle = CssStyle {
//    base { Modifier.margin(left = 10.px) }
//    Breakpoint.SM { Modifier.margin(left = 30.px) }
//    Breakpoint.MD { Modifier.margin(left = 95.px) }
//}
//
//val HeaderHomeIconStyle = CssStyle {
//    base { Modifier.size(18.px) }
//    Breakpoint.SM { Modifier.size(20.px) }
//    Breakpoint.MD { Modifier.size(24.px) }
//}
//
//val HeaderHomeTextStyle = CssStyle {
//    base { Modifier.fontSize(12.px) }
//    Breakpoint.SM { Modifier.fontSize(14.px) }
//    Breakpoint.MD { Modifier.fontSize(16.px) }
//}
//
//val HeaderTitleContainerStyle = CssStyle {
//    base { Modifier.margin(right = 30.px) }
//    Breakpoint.MD { Modifier.margin(right = 800.px) }
//}
//
//val HeaderTitleTextStyle = CssStyle {
//    base { Modifier.fontSize(12.px) }
//    Breakpoint.MD { Modifier.fontSize(16.px) }
//}
//
//val HeaderTitleIconStyle = CssStyle {
//    base { Modifier.size(18.px) }
//    Breakpoint.MD { Modifier.size(24.px) }
//}
//
//val HeaderThemeContainerStyle = CssStyle {
//    base { Modifier.margin(right = 10.px) }
//    Breakpoint.MD { Modifier.margin(right = 90.px) }
//}
//
//val HeaderThemeIconStyle = CssStyle {
//    base { Modifier.fontSize(18.px) }
//    Breakpoint.MD { Modifier.fontSize(25.px) }
//}

val ChooseCvMobileContainerStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .fillMaxWidth()
            .padding(top = 30.px, leftRight = 20.px)
    }
    Breakpoint.MD {
        Modifier.display(DisplayStyle.None)
    }
}

val ChooseCvDesktopContainerStyle = CssStyle {
    base {
        Modifier.display(DisplayStyle.None)
    }
    Breakpoint.MD {
        Modifier
            .display(DisplayStyle.Flex)
            .fillMaxWidth()
            .padding(topBottom = 60.px, leftRight = 5.percent) // Flex/pourcentage au lieu des pixels fixes
    }
}

// TYPOGRAPHIE
val ChooseCvTitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(24.px)
            .padding(bottom = 10.px)
    }
    cssRule(" span") {
        Modifier.styleModifier { property("font-size", "inherit") }
    }
    Breakpoint.MD {
        Modifier
            .styleModifier { property("font-size", "clamp(28px, 3vw, 42px)") }
            .padding(bottom = 0.px)
    }
}

val ChooseCvSubtitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(13.px)
            .margin(bottom = 25.px)
    }
    cssRule(" span") {
        Modifier.styleModifier { property("font-size", "inherit") }
    }
    Breakpoint.MD {
        Modifier
            .styleModifier { property("font-size", "clamp(14px, 1.2vw, 18px)") }
            .margin(bottom = 0.px)
    }
}

// CARTE CV
val CvCardBoxStyle = CssStyle {
    base {
        Modifier
            .width(320.px)
            .height(470.px)
    }
    Breakpoint.MD {
        Modifier
            .width(340.px)
            .height(500.px)
    }
}

// HEADER BAR STYLES
val HeaderPaddingStyle = CssStyle {
    base { Modifier.padding(12.px) }
    Breakpoint.SM { Modifier.padding(16.px) }
    Breakpoint.MD { Modifier.padding(leftRight = 5.percent, topBottom = 16.px) }
}

val HeaderHomeMarginStyle = CssStyle {
    base { Modifier.margin(left = 0.px) }
    Breakpoint.MD { Modifier.margin(left = 0.px) }
}

val HeaderHomeIconStyle = CssStyle {
    base { Modifier.fontSize(12.px) }
    Breakpoint.SM { Modifier.fontSize(14.px) }
    Breakpoint.MD { Modifier.fontSize(16.px) }
}

val HeaderHomeTextStyle = CssStyle {
    base { Modifier.fontSize(12.px) }
    Breakpoint.SM { Modifier.fontSize(14.px) }
    Breakpoint.MD { Modifier.fontSize(16.px) }
}

val HeaderTitleContainerStyle = CssStyle {
    base { Modifier.margin(right = 0.px) }
    Breakpoint.MD { Modifier.margin(right = 0.px) }
}

val HeaderTitleTextStyle = CssStyle {
    base { Modifier.fontSize(12.px) }
    Breakpoint.MD { Modifier.fontSize(16.px) }
}

val HeaderTitleIconStyle = CssStyle {
    base { Modifier.fontSize(12.px) }
    Breakpoint.MD { Modifier.fontSize(16.px) }
}

val HeaderThemeContainerStyle = CssStyle {
    base { Modifier.margin(right = 0.px) }
    Breakpoint.MD { Modifier.margin(right = 0.px) }
}

val HeaderThemeIconStyle = CssStyle {
    base { Modifier.fontSize(18.px) }
    Breakpoint.MD { Modifier.fontSize(22.px) }
}